// extracted by mini-css-extract-plugin
module.exports = {"stakeSelector":"_cf98e2d","caption":"_2bc7e1a","gameIcon":"_3eb28b5"};